import { User } from 'app/projects/user/src/lib/models/user';
export class RefreshUsersOnlineState {
    static readonly type = '[User] RefreshAllUsersOnlineState';

    constructor(public payload?: User[]) {}
}
